export default __webpack_public_path__ + "static/media/gothenburg_background_m2.ccd2715e.jpg";